import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'l-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss']
})
export class PageComponent implements OnInit {
  tabIndex: number = 0;
  @Input() tabHeadersIcons: string[];
  @Input() tabHeaders: string[];
  @Output() tabIndexChange: EventEmitter<number> = new EventEmitter<number>();

  constructor() { }

  ngOnInit(): void {
  }

  onTabChange(tabIndex: number) {
    this.tabIndexChange.emit(tabIndex);
  }
}
